
<template>
  <span>

    <a href="#" class="btn skin primary-button" @click="openModal" style="color:inherit;">browse flicker</a>

    <modal-in-front v-bind:title="map" ref="thisModal" size="modal-md">
      <div style="margin:auto;overflow:visible;position:relative">
        <div class="container-fluid">
          <div class="row">
            <div class="col-10 col-md-6">
              <input v-model="tag"
                     placeholder="Search for photos"
                     type="text"
                     class="form-control">
            </div>
            <div class="col-2">
              <button type="submit"
                      class="btn btn-success"
                      @click.prevent="search">
                Go
              </button>
            </div>
            <div class="col-4 mt-3 mt-md-0">
              <select class="form-control" v-model="size">
                <option value="landscape" selected>landscape</option>
                <option value="portrait">portrait</option>
                <option value="square">square</option>
              </select>
            </div>
            <div class="col-12">

              <div class="wrapper" style="max-height:400px;overflow-y:scroll;">
                <p v-if="loading" class="text-centered">
                  Loading...
                </p>
                <ul v-else class="image-card-grid">
                  <image-card @onclicked="onclicked" v-for="image in images"
                              :key="image.id"
                              :image="image" />
                </ul>
              </div>
            </div>
          </div>

        </div>
        </div>

</modal-in-front>
  </span>

</template>

<script>

  import ModalInFront from "../modals/modal-in-front.vue";
  import axios from 'axios';
  let jsonpAdapter = require('axios-jsonp');
  import ImageCard from "../imagehandling/Image-Card";
  
  export default {
    name: 'flickr-button',
    components: {
      ModalInFront,
      ImageCard
    },
    props: {
      
    },
    data() {
      return {
        api_key: "19ee5364888785abc8c5c931f44895b2",
        loading: false,
        tag: '',
        images: [],
        infoIconUrl : "https://developers.google.com/maps/documentation/javascript/examples/full/images/info-i_maps.png",
        jsonpAdapter,
        size: 'landscape',
      }
    },
    methods: {
      onclicked(image) {
        this.$emit("onclicked", image);
        this.$refs.thisModal.close();
      },
      openModal() {
        this.$refs.thisModal.open();
      },
      getId() {
        return this._uid;
      },
      search() {
        this.loading = true;
        this.fetchImages();
      },

      displayImages(response) {
        this.images = response.photos.photo;
        this.loading = false;
      },
      async fetchImages() {

        const headers = new Headers();
        //headers.append(
        //  "Authorization",
        //  this.api_key
        //);
        const request = new Request(
          "https://api.flickr.com/services/rest?method=flickr.photos.search&tags=" + this.tag + "&api_key=" + this.api_key + "&format=json&nojsoncallback=1&extras=url_n,owner_name,date_taken,views&orientation=" + this.size,
          {
            method: "GET",
            headers,
          }
        );
        const res = await fetch(request);
        const { photos } = await res.json();
        //alert(JSON.stringify(photos.photo))
        this.images = photos.photo;
        this.loading = false;
        /*
        axios({
          url: 'https://api.flickr.com/services/rest',
          adapter: jsonpAdapter,
          callbackParamName: 'c', // optional, 'callback' by default
          params: {
            method: 'flickr.photos.search',
            api_key: this.api_key,
            tags: this.tag,
            extras: 'url_n, owner_name, date_taken, views',
            page: 1,
            format: 'json',
            per_page: 30,
          }
        }).then((response) => {
          alert(JSON.stringify(response.data.photos))
          this.images = response.data.photos;
          this.loading = false;
        });
        */
      },
    },
    created() {

    },
    mounted() {
      window.jsonFlickrApi = this.displayImages;
    }
  }
</script>

<style scoped>


  .image-card-grid {
    list-style: none;
    margin: .5rem 0;
    padding: 0;
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/imagehandling/flickr-button.vue